import styled from "styled-components";

export const ContainerHeader = styled.header`
    background-color:#FF9636;
    height: 10vh;
    color: #0A4158;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 10px;
    gap: 20px;
`

export const LinkApi = styled.a`
    font-size: 30px;
    color: #E4D7D0;
    text-shadow: 1px 1px #000000;
`
